import { useState, useEffect } from 'react'
import { ChatWidget } from './ChatWidget'

/**
 * Renders ChatWidget only after client mount to avoid SSG/hydration mismatches.
 * ChatWidget uses sessionStorage and crypto.randomUUID() which are undefined during SSG.
 */
export function ClientOnlyChatWidget() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null
  return <ChatWidget />
}
